export default {
    count_down: {
        segundos: 'Segundos',
        minuto: 'Minuto',
        minutos: 'Minutos'
    },
    paginator: {
        quantidade_pagina: 'Cantidad por página',
        anterior: 'Anterior',
        proxima: 'Próximo',
        pagina: 'Página',
        de: 'en',
        ir_para: 'Ir a la página',
        por_pagina: 'Por página'
    },
    select: {
        sem_resultados: 'Sin resultados para',
        digite: 'Escribelo',
        letras: 'letras',
        nenhum_resultado: 'Sin resultados para',
        deseja_incluir: '¿Quieres incluir?',
        sim: 'Sí',
    },
    table_data: {
        valor: 'Valor',
        filtros: 'Filtros',
        gerenciar_colunas: 'Administrar Columnas',
        selecionar_todas: 'Seleccionar Todo',
        desmarcar_todas: 'Deseleccionar Todo',
    },
    bulk_form: {
        alterando: 'Estas cambiando ',
        registros: 'registros.',
        label_quantidade: 'Número de artículos con estos datos:',
        aplicar: 'Aplicar',
        messages: {
            quantidade: '¡Inserte la cantidad de registros que desea insertar!'
        }
    },
    form_generator: {
        habilitado: 'Habilitado',
        desabilitado: 'Deshabilitado',
        sem_informacao: 'No se encontró información'
    },
    exam_form: {
        nome: 'Nombre',
        codigo: 'Código',
        componente: 'Componente',
        material: 'Material',
        metodo: 'Método',
        tempo: 'Tiempo',
        escala: 'Escala'
    },
    exam_wizard_form: {
        sub_exame: 'Subexamen'
    },
    row_info: {
        titulo: 'Exámenes relacionados con el sinónimo.'
    },
    data_table: {
        todos: 'Todos',
        nenhum_resultado_encontrado: 'Ningún resultado encontrado',
        linhas_por_pagina: 'Líneas por página',
        proximo: 'Próximo',
        anterior: 'Anterior'
    },
    monitoring_filter: {
        legenda: 'Subtitular',
        filtros: 'Filtros',
        modo_monitor: 'Modo Monitor'
    },
    subtitle: {
        titulo: 'Leyenda de VNS',
        vns_novo: 'Nuevo',
        vns_novo_desc: 'VNS creado esperando la asignación de IP. No disponible para el cliente.',
        vns_ativo: 'Online',
        vns_ativo_desc: 'VNS activo y conectado a internet.',
        vns_desconectado: 'Desconectado',
        vns_desconectado_desc: 'VNS label conectado a la energía e internet, pero no conectado a la impresora o apagada.',
        vns_offline: 'Offline',
        vns_offline_desc: 'VNS no conectado a la energía y/o sin internet.',
        vns_em_analise: 'En Análisis',
        vns_em_analise_desc: 'VNS funcional, pero con alta temperatura.'
    }    
}
